import React, { useEffect, useState, useRef } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { Accordion, AccordionTab } from "primereact/accordion";
import { getItem, clearStorage, setItem } from "../../../utils/localStorage";
import { makeRequest2 } from "../../../utils/makeRequest";
import { getFacilityURL } from "../../../utils/urls";
import { usePermissions } from '../../../utils/permissions';
// import { useFacilityStore } from "../../../app/z-store/store";

function Nav() {
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate();
  const [userPermissions, setUserPermissions] = useState({});
  const [userName, setFullname] = useState("");
  const [userRole, setRole] = useState("");
  const [activeIndex, setActiveIndex] = useState(null);
  const navbarContentRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const [user, setUser] = useState(null);
  const permissions = usePermissions()(user);
  const [facilityId, setFacilityId] = useState(null);


  // Add these state variables at the top with other state declarations
  const [facilityModules, setFacilityModules] = useState({
    visitor: false,
    levy: false,
    maintenance: false,
    lease: false,
    vas: false,
    tickets: false,
    utility: false,
    booking: false,
    handover: false,
    expense: false,
    campaign: false,
    procurement: false,
    accounts: false,
    propertyManagement: false,
  });

  const [facilityLogo, setFacilityLogo] = useState(
    () => localStorage.getItem("selectedFacilityLogo") || "",
  );

  const HandleLogOut = async () => {
    await clearStorage();
    localStorage.removeItem("selectedFacilityLogo");
    navigate("/");
  };

  useEffect(() => {
    const loadFacilityId = async () => {
      const id = await getItem("selectedFacilityId");

      console.log("Facility ID:", id);

      setFacilityId(id);
    };

    loadFacilityId();
  }, []);

  // Save scroll position before navigation
  const handleLinkClick = (e) => {
    if (navbarContentRef.current) {
      setScrollPosition(navbarContentRef.current.scrollTop);
    }
  };
  // Restore scroll position after navigation
  useEffect(() => {
    if (navbarContentRef.current) {
      navbarContentRef.current.scrollTop = scrollPosition;
    }
  }, [currentPath, scrollPosition]);

  const getCurrentUser = async () => {
    try {
      const currentUserValue = await getItem("APPUSER");

      let currentUser;

      if (typeof currentUserValue === "string") {
        try {
          currentUser = JSON.parse(currentUserValue);
        } catch (err) {
          console.error("Error parsing APPUSER:", err);
        }
      } else {
        currentUser = currentUserValue;
      }

      if (currentUser?.user) {
        const fullName = currentUser.user.fullName;
        const role = currentUser.user.role;
        const permissions = currentUser.user.permissions || {};

        setFullname(fullName);
        setRole(role);
        setUser(currentUser.user);
        setUserPermissions(permissions);
      } else {
        console.error("Invalid user structure:", currentUser);
      }
    } catch (err) {
      console.error(err.message);
    }
  };

  const getFacilityLogo = async () => {
    try {
      // First check if logo is in navigation state
      const facilityFromState = location.state?.facility;

      if (facilityFromState?.logo) {
        // Store and use logo from state
        await setItem("selectedFacilityLogo", facilityFromState.logo);
        setFacilityLogo(facilityFromState.logo);
      } else {
        // Fallback to stored logo
        const storedLogo = await getItem("selectedFacilityLogo");
        setFacilityLogo(storedLogo || "");
      }
    } catch (error) {
      console.error("Error fetching facility logo:", error);

      // Final fallback: try localStorage
      const fallbackLogo = localStorage.getItem("selectedFacilityLogo");
      setFacilityLogo(fallbackLogo || "");
    }
  };

  const getFacilityModules = async () => {
    try {
      console.log("Facility ID:", facilityId);

      if (!facilityId) {
        console.log("No facility ID found");
        return;
      }

      const response = await makeRequest2(
        `${getFacilityURL}/${facilityId}`,
        "GET",
      );

      console.log("FRRRRESPONSE", response);

      if (response?.success && response?.data?.facility?.modules) {
        setFacilityModules(response.data.facility.modules);
      } else {
        console.warn("Invalid or missing modules data in response");
      }
    } catch (error) {
      console.error("Error fetching facility modules:", error);
    }
  };

  const getInitialActiveIndex = (path) => {
    if (path.includes("visitor_access_management")) return 0;
    if (path.includes("levy_management")) return 1;
    if (path.includes("maintenance")) return 2;
    if (path.includes("property_management")) return 3;
    if (path.includes("lease_management")) return 4;
    if (path.includes("value_added_services")) return 5;
    if (path.includes("ticket_management")) return 6;
    if (path.includes("utility_management")) return 7;
    if (path.includes("booking_management")) return 8;
    if (path.includes("handover_management")) return 9;
    if (path.includes("expense_management")) return 10;
    if (path.includes("campaigns")) return 11;
    if (path.includes("procurement")) return 12;
    if (path.includes("accounts")) return 13;
    // For supplier routes - set RFQ as default active
    if (path.includes("supplier_rfq_management")) return 0;
    return null;
  };

  useEffect(() => {
    getCurrentUser();
    getFacilityLogo();
  }, [location]);

  useEffect(() => {
    if (facilityId) {
      getFacilityModules();
    }
  }, [facilityId]);

  useEffect(() => {
    setActiveIndex(getInitialActiveIndex(currentPath));
  }, [currentPath]);

  const handleAccordionChange = (e) => {
    setActiveIndex(e.index);
  };

  return (
    <nav className="pc-sidebar">
      <div className="navbar-wrapper">
        <div className="m-header">
          {/* <Link to={"/facility/"} className="b-brand text-primary">
            <img
              src={facilityLogo}
              className="img-fluid logo-lg"
              alt="logo"
              style={{ width: 150, height: 70 }}
            />
            <span className="badge bg-light-success rounded-pill ms-2 theme-version">
              v1.0
            </span>
          </Link> */}
          <Link to={"/facility/"} className="b-brand text-primary">
            {facilityLogo ? (
              <img
                src={facilityLogo}
                className="img-fluid logo-lg"
                alt="facility logo"
                style={{ width: 150, height: 70, objectFit: 'contain' }}
                onError={(e) => {
                  // Fallback if image fails to load
                  e.target.style.display = 'none';
                  console.error('Failed to load logo:', facilityLogo);
                }}
              />
            ) : (
              <div
                className="logo-placeholder"
                style={{ width: 150, height: 70, display: 'flex', alignItems: 'center' }}
              >
                <span>PayServe</span>
              </div>
            )}
            <span className="badge bg-light-success rounded-pill ms-2 theme-version">
              v1.0
            </span>
          </Link>
        </div>

        <div className="navbar-content" style={{ overflowY: "scroll" }}>
          <div className="card pc-user-card">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <img
                    src="/assets/images/user/avatar-1.jpg"
                    alt="user-image"
                    className="user-avtar wid-45 rounded-circle"
                  />
                </div>
                <div className="flex-grow-1 ms-3 me-2">
                  <h6 className="mb-0">{userName}</h6>
                </div>
                <Link
                  className="btn btn-icon btn-link-secondary avtar"
                  data-bs-toggle="collapse"
                  to="#pc_sidebar_userlink"
                >
                  <svg className="pc-icon">
                    <use xlinkHref="#custom-sort-outline" />
                  </svg>
                </Link>
              </div>

              <div className="collapse pc-user-links" id="pc_sidebar_userlink">
                <div className="pt-3">
                  {userRole !== "guard" &&
                    userRole !== "Staff" &&
                    userRole !== "reception" &&
                    userRole !== "supplier" && (
                      <Link to={"/facility/settings_management/settings"}>
                        <i className="ti ti-settings" />
                        <span>Settings</span>
                      </Link>
                    )}
                  <Link
                    to={"#!"}
                    onClick={() => {
                      HandleLogOut();
                    }}
                  >
                    <i className="ti ti-power" />
                    <span>Logout</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <ul className="pc-navbar mb-5">
            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath === "/app/facilities/" ? "active" : ""
                  }`}
              >
                <Link to={"/app/facilities"} className="pc-link">
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-logout" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Home Page</span>
                </Link>
              </li>
            )}

            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath === "/facility" ? "active" : ""
                  }`}
              >
                <Link to={"/facility"} className="pc-link">
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-home" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Dashboard</span>
                </Link>
              </li>
            )}

            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath === "/facility/unit_management" ? "active" : ""
                  }`}
              >
                <Link to={"/facility/unit_management"} className="pc-link">
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-element-plus" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Unit Management</span>
                </Link>
              </li>
            )}

            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath === "/facility/customer_management/customers" ||
                  currentPath ===
                  "/facility/customer_management/add_new_customer"
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={"/facility/customer_management/customers"}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-profile-2user-outline" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Customer Management</span>
                </Link>
              </li>
            )}

            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath === "/facility/payment_management/" + facilityId
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/payment_management/${facilityId}`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-keyboard" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Finance Management</span>
                </Link>
              </li>
            )}

            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath ===
                  "/facility/common_area_management/" + facilityId
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/common_area_management/${facilityId}`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-cpu-charge" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Common Area Utility</span>
                </Link>
              </li>
            )}

            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath ===
                  "/facility/reports/all_reports/"
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/reports/all_reports`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-folder-open" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Reports</span>
                </Link>
              </li>
            )}


            {userRole !== "guard" && userRole !== "reception" && userRole !== "supplier" && (
              <li
                className={`pc-item ${currentPath ===
                  "/facility/combined_invoices/combined_invoices/"
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/combined_invoices/combined_invoices`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-note-1" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Combined Invoices</span>
                </Link>
              </li>
            )}

            {userRole === "ninja" && (
              <li
                className={`pc-item ${currentPath.startsWith("/facility/audit_logs") ? "active" : ""}`}
              >
                <Link to={`/facility/audit_logs`} className="pc-link">
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-security-safe" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Audit Logs</span>
                </Link>
              </li>
            )}

            {/* SUPPLIER SPECIFIC MENU ITEMS */}
            {userRole === "supplier" && (
              <li
                className={`pc-item ${currentPath ===
                  "/facility/supplier_rfq_management/rfqs_management"
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/supplier_rfq_management/rfqs_management`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-document-text" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Request For Quotations</span>
                </Link>
              </li>
            )}

            {userRole === "supplier" && (
              <li
                className={`pc-item ${currentPath ===
                  "/facility/supplier_purchase_orders_management/purchase_orders"
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/supplier_purchase_orders_management/purchase_orders`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-bag" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Purchase Orders</span>
                </Link>
              </li>
            )}

            {userRole === "supplier" && (
              <li
                className={`pc-item ${currentPath ===
                  "/facility/supplier_invoices_management/invoices"
                  ? "active"
                  : ""
                  }`}
              >
                <Link
                  to={`/facility/supplier_invoices_management/invoices`}
                  className="pc-link"
                >
                  <span className="pc-micon">
                    <svg className="pc-icon">
                      <use xlinkHref="#custom-receipt" />
                    </svg>
                  </span>
                  <span className="pc-mtext">Invoices</span>
                </Link>
              </li>
            )}

            <Accordion
              activeIndex={activeIndex}
              onTabChange={handleAccordionChange}
            >
              {userRole !== "Staff" &&
                facilityModules.visitor &&
                permissions.hasModuleAccess("visitorAccess") && (
                  <AccordionTab
                    header={
                      <div className="flex items-center text-dark">
                        <span>Visitor & Access </span>
                      </div>
                    }
                  >
                    {userRole === "guard" && (
                      <li
                        className={`pc-item ${currentPath ===
                          "/facility/visitor_access_management/home/" ||
                          currentPath ===
                          "/facility/visitor_access_management/home"
                          ? "active"
                          : ""
                          }`}
                      >
                        <Link
                          to={"/facility/visitor_access_management/home/"}
                          className="pc-link"
                          onClick={handleLinkClick}
                        >
                          <span className="pc-micon">
                            <svg className="pc-icon">
                              <use xlinkHref="#custom-home" />
                            </svg>
                          </span>

                          <span className="pc-mtext">Home</span>
                        </Link>
                      </li>
                    )}

                    {userRole !== "guard" && (
                      <>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/digital_logs/"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/digital_logs/"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-keyboard" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Digital Logs</span>
                          </Link>
                        </li>
                      </>
                    )}

                    {userRole === "guard" && (
                      <>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/scan_qr_code/"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/scan_qr_code/"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-cpu-charge" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Scan QR Code</span>
                          </Link>
                        </li>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/verify_code/"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/verify_code/"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-24-support" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Verify Code</span>
                          </Link>
                        </li>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_management/gate_registration" ||
                            currentPath ===
                            "/facility/visitor_access_management/visitor_registration/gate_registration"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/visitor_registration/gate_registration"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-user-add" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Gate Registration</span>
                          </Link>
                        </li>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_management/deliveries" ||
                            currentPath ===
                            "/facility/visitor_access_management/visitor_registration/deliveries"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/visitor_registration/deliveries"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-shopping-bag" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Delivery</span>
                          </Link>
                        </li>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/waiting_list" ||
                            currentPath ===
                            "/facility/visitor_access_management/waiting_list"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/waiting_list"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-flag" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Waiting List</span>
                          </Link>
                        </li>
                      </>
                    )}

                    {userRole !== "guard" && (
                      <>
                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/reception" ||
                            currentPath ===
                            "/facility/visitor_access_management/receptionist_management/reception"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={"/facility/visitor_access_management/reception"}
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-user-bold" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Receptionists</span>
                          </Link>
                        </li>

                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/add_receptionist" ||
                            currentPath ===
                            "/facility/visitor_access_management/receptionist_management/add_receptionist"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={"/facility/visitor_access_management/add_receptionist"}
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-mouse-circle" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Add Receptionists</span>
                          </Link>
                        </li>

                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/guard_list" ||
                            currentPath ===
                            "/facility/visitor_access_management/guard_registration/register_guard"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={"/facility/visitor_access_management/guard_list"}
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-security-safe" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Guard Management</span>
                          </Link>
                        </li>

                        <li
                          className={`pc-item ${currentPath ===
                            "/facility/visitor_access_management/entries_and_exits" ||
                            currentPath ===
                            "/facility/visitor_access_management/entries_and_exits/add_entry_and_exit"
                            ? "active"
                            : ""
                            }`}
                        >
                          <Link
                            to={
                              "/facility/visitor_access_management/entries_and_exits"
                            }
                            className="pc-link"
                            onClick={handleLinkClick}
                          >
                            <span className="pc-micon">
                              <svg className="pc-icon">
                                <use xlinkHref="#custom-data" />
                              </svg>
                            </span>

                            <span className="pc-mtext">Entries & Exits</span>
                          </Link>
                        </li>
                      </>
                    )}
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.levy &&
                permissions.hasModuleAccess("levy") &&
                (
                  <AccordionTab
                    header={
                      <div className="flex items-center text-dark">
                        <span>Levy </span>
                      </div>
                    }
                  >
                    {permissions.canRead("levy") && (
                      <li
                        className={`pc-item ${currentPath === "/facility/levy_management" ||
                          currentPath ===
                          "/facility/levy_management/levies/add_levy"
                          ? "active"
                          : ""
                          }`}
                      >
                        <Link
                          to={"/facility/levy_management"}
                          className="pc-link"
                          onClick={handleLinkClick}
                        >
                          <span className="pc-micon">
                            <svg className="pc-icon">
                              <use xlinkHref="#custom-graph" />
                            </svg>
                          </span>
                          <span className="pc-mtext">Levy Registration</span>
                        </Link>
                      </li>
                    )}

                    <li
                      className={`pc-item ${currentPath === "/facility/levy_management/contracts" ||
                        currentPath ===
                        "/facility/levy_management/contracts/add_contract"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/levy_management/contracts"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-link" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Levy Details</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facilitiy/levy_management/levy_invoicing"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facilitiy/levy_management/levy_invoicing"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-keyboard" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Levy Invoicing</span>
                      </Link>
                      <Link
                        to={"/facilitiy/levy_management/levy_deposits"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-dollar-square" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Levy Deposits</span>
                      </Link>
                      <Link
                        to={"/facilitiy/levy_management/levy_reports"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-presentation-chart" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Levy Reports</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.maintenance &&
                permissions.hasModuleAccess("maintenance") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Maintenance</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/maintenance/work_order_management"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/maintenance/work_order_management"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-simcard-2" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Work Order </span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath === "/facility/maintenance/sla"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/maintenance/sla"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-note-1" />
                          </svg>
                        </span>
                        <span className="pc-mtext">SLA Management</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath === "/facility/maintenance/asset"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/maintenance/asset"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-layer" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Asset Management</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/maintenance/stock_and_spare_parts"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/maintenance/stock_and_spare_parts"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-clipboard" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Stock & Spare Parts</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/maintenance/workplan_management"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/maintenance/workplan_management"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-profile-2user-outline" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Staff Management</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.propertyManagement &&
                permissions.hasModuleAccess("propertyManagement") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Property Management</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/property_management/property_contract_management"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={
                          "/facility/property_management/property_contract_management"
                        }
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-home" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Contracts</span>
                      </Link>
                    </li>

                    {/* <li
                    className={`pc-item ${currentPath === "/facility/property_management"
                      ? "active"
                      : ""
                      }`}
                  >
                    <Link
                      to={"/facility/property_management"}
                      className="pc-link"
                      onClick={handleLinkClick}
                    >
                      <span className="pc-micon">
                        <svg className="pc-icon">
                          <use xlinkHref="#custom-home" />
                        </svg>
                      </span>
                      <span className="pc-mtext">Properties</span>
                    </Link>
                  </li> */}

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/property_management/property_customers"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/property_management/property_customers"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-profile-2user-outline" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Apartments</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/property_management/property_invoices"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/property_management/property_invoices"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-setting-2" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Invoices</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/property_management/property_revenue"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/property_management/property_revenue"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-dollar-square" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Revenue</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.lease &&
                permissions.hasModuleAccess("lease") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Lease Management</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/lease_management/lease_templates"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/lease_management/lease_templates"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-shapes" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Lease Templates</span>
                      </Link>
                    </li>
                    {permissions.canCreate("lease") && (
                      <li
                        className={`pc-item ${currentPath === "/facility/lease_management/leases"
                          ? "active"
                          : ""
                          }`}
                      >
                        <Link
                          to={"/facility/lease_management/leases"}
                          className="pc-link"
                          onClick={handleLinkClick}
                        >
                          <span className="pc-micon">
                            <svg className="pc-icon">
                              <use xlinkHref="#custom-note-1" />
                            </svg>
                          </span>

                          <span className="pc-mtext">Lease Agreements</span>
                        </Link>
                      </li>
                    )}

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/lease_management/lease_invoices"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/lease_management/lease_invoices"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-direct-inbox" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Lease Invoices</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/lease_management/lease_penalties"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/lease_management/lease_penalties"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-keyboard" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Lease Penalties</span>
                      </Link>
                      <Link
                        to={"/facilitiy/lease_management/lease_reports"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-presentation-chart" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Lease Reports</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.vas &&
                permissions.hasModuleAccess("vas") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>VAS</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/value_added_services/service_vendors"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/value_added_services/service_vendors"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <i className="fas fa-users"></i>{" "}
                          {/* Icon for Service Vendors */}
                        </span>
                        <span className="pc-mtext">Services</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/value_added_services/vas_vendors"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/value_added_services/vas_vendors"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <i className="fas fa-users-cog"></i>{" "}
                          {/* Icon for Service Vendors */}
                        </span>
                        <span className="pc-mtext">Service Vendors</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/value_added_services/service_list"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/value_added_services/service_list"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <i className="fas fa-briefcase"></i>{" "}
                          {/* Font Awesome icon for services to display */}
                        </span>
                        <span className="pc-mtext">Service Requests</span>
                      </Link>
                    </li>

                    {/* <li className={`pc-item ${currentPath === '/facility/value_added_services/service_requests' ? 'active' : ''}`}>
                  <Link to={'/facility/value_added_services/service_requests'} className="pc-link">
                    <span className="pc-micon">
                      <i className="fas fa-handshake"></i> {
                    </span>
                    <span className="pc-mtext">Service Requests</span>
                  </Link>
                </li> */}

                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/value_added_services/vas_invoices"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/value_added_services/vas_invoices"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <i className="fas fa-file-invoice"></i>{" "}
                          {/* Icon for Vas Invoices */}
                        </span>
                        <span className="pc-mtext">Vas Invoices</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.tickets &&
                permissions.hasModuleAccess("tickets") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Tickets</span>
                      </div>
                    }
                  >
                    {/* {userPermissions?.Tickets?.create && ( */}
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/ticket_management/raise_ticket" ||
                        currentPath ===
                        "/facility/ticket_management/raise_ticket"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/ticket_management/raise_ticket"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-text-block" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Raise Ticket</span>
                      </Link>
                    </li>
                    {/* )} */}
                    {/* {userPermissions?.Tickets?.review && ( */}
                    <li
                      className={`pc-item ${currentPath === "/facility/ticket_management/tickets" ||
                        currentPath === "/facility/ticket_management/tickets"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/ticket_management/tickets"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-text-align-justify-center" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Raised Tickets</span>
                      </Link>
                    </li>
                    {/* )} */}

                    {userRole === "Staff" && (
                      <li
                        className={`pc-item ${currentPath ===
                          "/facility/ticket_management/assigned_tickets" ||
                          currentPath ===
                          "/facility/ticket_management/assigned_tickets"
                          ? "active"
                          : ""
                          }`}
                      >
                        <Link
                          to={"/facility/ticket_management/assigned_tickets"}
                          className="pc-link"
                          onClick={handleLinkClick}
                        >
                          <span className="pc-micon">
                            <svg className="pc-icon">
                              <use xlinkHref="#custom-text-block" />
                            </svg>
                          </span>
                          <span className="pc-mtext">Assigned Tickets</span>
                        </Link>
                      </li>
                    )}

                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.utility &&
                permissions.hasModuleAccess("utility") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Utility</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath === "/facility/utility_management/" ||
                        currentPath === "/facility/utility_management/"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/utility_management/meter_types/"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-cpu-charge" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Meters Management</span>
                      </Link>
                      {/* <Link
                      to={"/facility/utility_management/billing/"}
                      className="pc-link"
                      onClick={handleLinkClick}
                    >
                      <span className="pc-micon">
                        <svg className="pc-icon">
                          <use xlinkHref="#custom-dollar-square" />
                        </svg>
                      </span>
                      <span className="pc-mtext">Billing Management</span>
                    </Link> */}
                      <Link
                        to={"/facilitiy/utility_management/utility_reports"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-presentation-chart" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Utility Reports</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.booking &&
                permissions.hasModuleAccess("booking") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Booking</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/booking_management/unit_listing"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/booking_management/unit_listing"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-crop" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Unit Listing</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath === "/facility/booking_management" ? "active" : ""}`}
                    >
                      <Link
                        to={"/facility/booking_management"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-note-1" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Booking</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath === "/facility/booking_management/invoices" ? "active" : ""}`}
                    >
                      <Link
                        to={"/facility/booking_management/invoices"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-direct-inbox" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Invoice</span>
                      </Link>
                    </li>

                    <li
                      className={`pc-item ${currentPath === "/facility/booking_management/settings" ? "active" : ""}`}
                    >
                      <Link
                        to={"/facility/booking_management/settings"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-setting-2" />
                          </svg>
                        </span>

                        <span className="pc-mtext">Booking Settings</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.handover &&
                permissions.hasModuleAccess("handover") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Handover</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/handover_management/handovers"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/handover_management/handovers/"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-row-vertical" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Handovers</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/handover_management/reports"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/handover_management/reports"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-presentation-chart" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Handover Reports</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.expense &&
                permissions.hasModuleAccess("expense") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Expense & Budget</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath === "/facility/expense_management/budget" ||
                        currentPath === "/facility/expense_management/budget"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/expense_management/budget"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-status-up" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Budget</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath === "/facility/expense_management" ||
                        currentPath === "/facility/expense_management"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/expense_management"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-dollar-square" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Expense</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/expense_management/reports" ||
                        currentPath === "/facility/expense_management/reports"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/expense_management/reports"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-fatrows" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Reports & Analytics</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.campaign &&
                permissions.hasModuleAccess("campaigns") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Campaigns</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath === "/facility/campaigns" ? "active" : ""
                        }`}
                    >
                      <Link
                        to={"/facility/campaigns"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-row-vertical" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Campaigns</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.procurement &&
                permissions.hasModuleAccess("procurement") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Procurement</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/procurement_management/purchase_orders"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/procurement_management/purchase_orders/"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-bag" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Purchase Orders</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/procurement_management/purchase_requests"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={
                          "/facility/procurement_management/purchase_requests/"
                        }
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-row-vertical" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Purchase Requests</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/procurement_management/quotations_management"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={
                          "/facility/procurement_management/quotations_management/"
                        }
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-refresh-2" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Quotations</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/procurement_management/supplier_management"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={
                          "/facility/procurement_management/supplier_management/"
                        }
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-profile-2user-outline" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Suppliers</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath ===
                        "/facility/procurement_management/settings"
                        ? "active"
                        : ""
                        }`}
                    >
                      <Link
                        to={"/facility/procurement_management/settings/"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-setting-2" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Settings</span>
                      </Link>
                    </li>
                  </AccordionTab>
                )}

              {userRole !== "guard" &&
                userRole !== "supplier" &&
                facilityModules.accounts &&
                permissions.hasModuleAccess("accounts") && (
                  <AccordionTab
                    header={
                      <div className="flex align-items-center text-dark">
                        <span>Accounts</span>
                      </div>
                    }
                  >
                    <li
                      className={`pc-item ${currentPath === "/facilitiy/accounts" ? "active" : ""
                        }`}
                    >
                      <Link
                        to={"/facilitiy/accounts"}
                        className="pc-link"
                        onClick={handleLinkClick}
                      >
                        <span className="pc-micon">
                          <svg className="pc-icon">
                            <use xlinkHref="#custom-row-vertical" />
                          </svg>
                        </span>
                        <span className="pc-mtext">Accounts</span>
                      </Link>
                    </li>
                    <li
                      className={`pc-item ${currentPath === "/facilitiy/accounts/reports"
                        ? "active"
                        : ""
                        }`}
                    ></li>
                  </AccordionTab>
                )}
            </Accordion>
          </ul>
        </div>
      </div>
    </nav>
  );
}
export default Nav;
